import axios from 'axios';
import { TRAPPED_COMMUNICATIONS_API } from 'Constants';
import { stringNotEmpty } from 'Util/TypeGuards';

export type TrappedCommunicationType = 'Email' | 'Sms';
export type TrappedCommunicationStatus = 'Sent' | 'Failed' | 'Skipped';

export interface TrappedCommunicationListItem {
	id: string;
	created: string;
	type: TrappedCommunicationType;
	status: TrappedCommunicationStatus;
	recipient: string;
	subject: string | null;
}

export interface TrappedCommunicationDetail extends TrappedCommunicationListItem {
	/** The raw JSON payload of the communication (email: subject/body/to/cc/bcc, sms: message). */
	content: string;
	error: string | null;
}

export interface TrappedCommunicationFilters {
	searchString?: string;
	type?: TrappedCommunicationType;
	skip?: number;
	take?: number;
}

export async function fetchTrappedCommunications(
	filters: TrappedCommunicationFilters,
): Promise<{ data: TrappedCommunicationListItem[]; count: number }> {
	const params = new URLSearchParams();

	if (stringNotEmpty(filters.searchString)) {
		params.append('searchString', filters.searchString!);
	}
	if (filters.type) {
		params.append('type', filters.type);
	}
	if (filters.skip !== undefined) {
		params.append('skip', filters.skip.toString());
	}
	if (filters.take !== undefined) {
		params.append('take', filters.take.toString());
	}

	const response = await axios.get(TRAPPED_COMMUNICATIONS_API, { params });

	return {
		data: response.data.data as TrappedCommunicationListItem[],
		count: response.data.count as number,
	};
}

export async function fetchTrappedCommunication(id: string): Promise<TrappedCommunicationDetail> {
	const response = await axios.get(`${TRAPPED_COMMUNICATIONS_API}/${id}`);
	return response.data as TrappedCommunicationDetail;
}
